/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_HeadingInputs */

const tr_iletisim_s6_heading = /** @type {(inputs: Iletisim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yasal Bilgi`)
};

const en_iletisim_s6_heading = /** @type {(inputs: Iletisim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal information`)
};

const de_iletisim_s6_heading = /** @type {(inputs: Iletisim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtliche Angaben`)
};

const ru_iletisim_s6_heading = /** @type {(inputs: Iletisim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юридическая информация`)
};

/**
* | output |
* | --- |
* | "Legal information" |
*
* @param {Iletisim_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_heading = /** @type {((inputs?: Iletisim_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_heading(inputs)
	if (locale === "de") return de_iletisim_s6_heading(inputs)
	if (locale === "ru") return ru_iletisim_s6_heading(inputs)
	return tr_iletisim_s6_heading(inputs)
});